/**
 * Error Message Component
 *
 * Displays error messages in a styled container.
 */

import { useTranslation } from 'react-i18next';

interface ErrorMessageProps {
  message: string;
}

export function ErrorMessage({ message }: ErrorMessageProps) {
  const { t } = useTranslation();

  return (
    <div className="bg-red-50 rounded-lg border border-red-200 p-6 text-center">
      <svg className="w-8 h-8 text-red-500 mx-auto mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
      </svg>
      <p className="text-sm text-red-700">{message}</p>
      <p className="text-xs text-red-500 mt-1">{t('courses.tryAgainLater')}</p>
    </div>
  );
}
